import { useMemo } from "react";
import DeviceContext from "@/components/generic/customHooks/indentifyDevice";

const useCalculateZoom = () => {
  const device = DeviceContext();
  const sales_jwt_token: boolean = Boolean(
    localStorage.getItem("sales_jwt_token"),
  );
  const sales_native_app: boolean =
    JSON.parse(localStorage.getItem("sales_native_app")) === true;
  const isRMApp =
    (Boolean(window.self !== window.top) && sales_jwt_token) ||
    sales_native_app;
  const zoom = useMemo(() => {
    const screenWidth = window.screen.width;
    const isMobileorTab = device?.isMobile || device?.isTablet;
    if (isMobileorTab || isRMApp) {
      return "100%";
    }
    const zoomRanges = {
      range1: { min: 1023, max: 1299, value: 88 },
      range2: { min: 1300, max: 1499, value: 90 },
      range3: { min: 1500, max: 1699, value: 92 },
    };
    const defaultZoom = 100;
    const matchingRange = Object.values(zoomRanges).find(
      (range) => screenWidth >= range.min && screenWidth <= range.max,
    );
    const zoomValue = matchingRange ? matchingRange.value : defaultZoom;
    return zoomValue + "%";
  }, [device]);

  return zoom;
};

export default useCalculateZoom;
